var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-card",
        [
          _c(
            "v-snackbar",
            {
              attrs: { timeout: 30000, top: true, color: _vm.toastColor },
              model: {
                value: _vm.toastEnable,
                callback: function($$v) {
                  _vm.toastEnable = $$v
                },
                expression: "toastEnable"
              }
            },
            [
              _vm._v("\n      " + _vm._s(_vm.toastText) + "\n      "),
              _c(
                "v-btn",
                {
                  attrs: { dark: "", flat: "" },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      _vm.toastEnable = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("close")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-layout",
        [
          _c(
            "v-flex",
            [
              _c(
                "v-btn",
                {
                  attrs: {
                    dark: "",
                    bottom: "",
                    right: "",
                    color: "primary",
                    title: "add user"
                  },
                  on: { click: _vm.showAddUserDialog }
                },
                [
                  _c("v-icon", { attrs: { dark: "" } }, [_vm._v("add")]),
                  _vm._v(" " + _vm._s(_vm.$t("staff")) + "\n      ")
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-layout",
        { staticClass: "subheading", attrs: { "align-baseline": "" } },
        [
          _c("v-flex", _vm._b({}, "v-flex", _vm.flexAttr, false), [
            _vm._v(_vm._s(_vm.$t("name")))
          ]),
          _vm._v(" "),
          _c(
            "v-flex",
            _vm._b(
              { staticClass: "text-xs-left" },
              "v-flex",
              _vm.flexAttr,
              false
            ),
            [_vm._v(_vm._s(_vm.$t("email")))]
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            { staticClass: "text-xs-left", attrs: { xs12: "", md3: "" } },
            [_vm._v(_vm._s(_vm.$t("role")))]
          ),
          _vm._v(" "),
          _vm.isWarehouse
            ? _c(
                "v-flex",
                { staticClass: "text-xs-left", attrs: { xs12: "", md3: "" } },
                [_vm._v(_vm._s(_vm.$t("warehouseSite")))]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-flex",
            { staticClass: "text-xs-center", attrs: { xs12: "", md2: "" } },
            [_vm._v(_vm._s(_vm.$t("note")))]
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            { staticClass: "text-xs-center", attrs: { xs12: "", md2: "" } },
            [_vm._v(_vm._s(_vm.$t("actions")))]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("v-divider", { staticClass: "mb-3" }),
      _vm._v(" "),
      _vm._l(_vm.users, function(item, index) {
        return _c(
          "v-layout",
          { key: item.name + index, attrs: { "align-baseline": "" } },
          [
            _c("v-flex", _vm._b({}, "v-flex", _vm.flexAttr, false), [
              _c("div", [_vm._v(_vm._s(item.name))]),
              _vm._v(" "),
              !!item.lastLoginTime
                ? _c("div", [
                    _vm._v(
                      _vm._s(
                        _vm.toTimestampString(new Date(item.lastLoginTime))
                      )
                    )
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c(
              "v-flex",
              _vm._b(
                { staticClass: "text-xs-left" },
                "v-flex",
                _vm.flexAttr,
                false
              ),
              [
                _c("p", { staticStyle: { "text-align": "left" } }, [
                  _vm._v(_vm._s(item.email))
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "v-flex",
              { staticClass: "text-xs-left", attrs: { xs12: "", md3: "" } },
              _vm._l(item.roles, function(role) {
                return _c("v-chip", { key: role }, [
                  _vm._v(_vm._s(_vm.permissionValueToText.get(role)))
                ])
              }),
              1
            ),
            _vm._v(" "),
            _vm.isWarehouse
              ? _c(
                  "v-flex",
                  { staticClass: "text-xs-left", attrs: { xs12: "", md3: "" } },
                  _vm._l(
                    _vm.getWarehouseSitesNames(item.sites, index),
                    function(site) {
                      return _c(
                        "v-chip",
                        {
                          key: site,
                          class: { whiteColor: site === "ALL" },
                          attrs: {
                            color: site === "ALL" ? "primary" : "default"
                          }
                        },
                        [_vm._v("\n        " + _vm._s(site) + "\n      ")]
                      )
                    }
                  ),
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "v-flex",
              { staticClass: "text-xs-center", attrs: { xs12: "", md2: "" } },
              [
                _c(
                  "div",
                  {
                    ref: "" + item.email,
                    refInFor: true,
                    staticClass: "text-overflow-hide",
                    staticStyle: { cursor: "pointer" },
                    on: {
                      click: function($event) {
                        return _vm.toggleOverflowStyle("" + item.email)
                      }
                    }
                  },
                  [_vm._v(_vm._s(item.note))]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "v-flex",
              { staticClass: "text-xs-center", attrs: { xs12: "", md2: "" } },
              [
                index !== 0
                  ? _c(
                      "v-btn",
                      {
                        attrs: { dark: "", color: "primary", flat: "" },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.showEditUserDialog(item)
                          }
                        }
                      },
                      [_vm._v("Edit")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                index !== 0
                  ? _c(
                      "v-btn",
                      {
                        attrs: { dark: "", color: "primary", flat: "" },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.removeUser(item)
                          }
                        }
                      },
                      [_vm._v("Delete")]
                    )
                  : _c("span", [_vm._v(_vm._s(_vm.$t("owner")))])
              ],
              1
            )
          ],
          1
        )
      }),
      _vm._v(" "),
      _vm.roleEditDialog
        ? _c("PermissionEditPopup", {
            attrs: {
              isEdit: _vm.isEdit,
              initUser: _vm.userInEdit,
              actionFunc: _vm.isEdit ? _vm.editUser : _vm.addUser,
              isWarehouseOwner: _vm.isWarehouseOwner
            },
            model: {
              value: _vm.roleEditDialog,
              callback: function($$v) {
                _vm.roleEditDialog = $$v
              },
              expression: "roleEditDialog"
            }
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-dab75ef8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dab75ef8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Permissions.vue
// module id = null
// module chunks = 